export const PRIVILEGES = {
  AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER:
    'AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER',
  AAD_ADMIN_CONSOLE_CHANNELS_ADMIN: 'AAD_ADMIN_CONSOLE_CHANNELS_ADMIN',
  AAD_ADMIN_CONSOLE_CHANNELS_TEST: 'AAD_ADMIN_CONSOLE_CHANNELS_TEST',
  AAD_ADMIN_CONSOLE_CRM_MANAGER: 'AAD_ADMIN_CONSOLE_CRM_MANAGER',
  GS_MA: 'GS-MA',
  FILIALLEITER_ALL: 'Filialleiter.ALL',
  CC_START: 'CC_Start',
  CC_SUPERVISOR: 'CC_Supervisor',
  BESCHWERDE_MANAGEMENT_TEAM: 'Beschwerde Management Team',
  CSC_PROZESS_INFO: 'CSC Prozess & Info',
  TEAM_GIRO: 'Team_GIRO',
  TEAM_EXELA: 'Team_EXELA',
  ZERO_ZERO_ONE: '001',
  MWP_FSLOGIX_AZFS_2: 'MWP_FSLogix_AZFS-2',
  OUTLOOK: 'Outlook',
  GS001_DX_DXA_DXAP: 'GS001.DX.DXA.DXAP',
  PAYLIFE_ADMIN_TST: 'PAYLIFE_ADMIN_TST',
  ORA_VFR_12C: 'ORA_VFR_12C',
  MWP_FSLOGIX_FS3_1: 'MWP_FSLogix_FS3-1',
  MIA_1: 'MIA_1',
  DOMAIN_USERS_ALL_INTERN: 'Domänen-Benutzer_ALL_intern',
  MWP_EXTERNAL_ACCESS_AZURE_MFA: 'MWP_external_access_Azure_MFA',
  AKS_DEVELOPER: 'AKS_DEVELOPER',
  OUTLOOK_WEB: 'OutlookWeb',
  MWP_ZSCALER_PROXY_PAC: 'MWP_Zscaler_Proxy_pac',
  ALL_MAILBOXES: 'All Mailboxes',
  EASY_ADMIN_UAT: 'EASY_ADMIN_UAT',
  MWP_AZURE_DESKTOP: 'MWP_Azure_Desktop',
  KLAR_ADMIN_UAT: 'KLAR_ADMIN_UAT',
  LANGUAGE_PACK_ENGLISH: 'Language_Pack_English',
  PAYLIFE_ADMIN_PRD: 'PAYLIFE_ADMIN_PRD',
  KLAR_ADMIN_PRD: 'KLAR_ADMIN_PRD',
  EASY_ADMIN_PRD: 'EASY_ADMIN_PRD',
  AAD_LINUX_AKS_ADMIN: 'AAD_Linux_AKS_Admin',
  LIBRA_OPERATOR: 'LIBRA_OPERATOR',
  AAD_GITHUB_LIBRA_OPERATIONS_TEAM: 'AAD_GitHub_LibraOperationsTeam',
  NONE: 'NONE',
};

export type Privilege = (typeof PRIVILEGES)[keyof typeof PRIVILEGES];
